import styled from '@emotion/styled';
import { Magnetic } from '../../styles';
export const MainDropdownLayout = styled('div')(`
	justify-content: space-between;
	line-height: 2.5rem;
	padding: 0 ${Magnetic.spacer20};
	text-align: center;
`);
export const GlobeColor = styled('i')((props) => `
    color:${props.globeColor};
`);
export const LanguageDropDownContent = styled('select')((props) => `	
	background-color: transparent;
	border: none;
	color: ${props.fontColor};
	font-size: ${props.fontSize};
	min-width: ${Magnetic.microcardMinWidth};
	padding: 0 0 ${Magnetic.spacer04};
	text-align: ${Magnetic.menuItemAlignItems};
	text-decoration: ${Magnetic.iconCoreTextTransform};
	vertical-align: middle;
	text-transform: ${Magnetic.labelValuePairLabelTextTransform};	
	margin-bottom: ${Magnetic.buttonFlatMinWidth};	
	background-image: linear-gradient(to bottom, transparent 0%, transparent 100%);
		
	&:focus{
		outline: none;
	}
`);
//# sourceMappingURL=WhiteLabelMobileDropdown.style.js.map